<template>
  <aside class="aside" :class="{ asideOpen: mobileMenuActive }">
    <div class="aside-brand">
      <div class="logo">
        <img src="../assets/image/logo.png" alt="logo" />
      </div>
    </div>
    <TheMenu></TheMenu>
  </aside>
</template>

<script>
import TheMenu from "../components/TheMenu";
import { mapGetters } from "vuex";

export default {
  name: "TheSidebar",
  components: { TheMenu },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("app", ["mobileMenuActive"]),
  }
};
</script>